<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Editar capa</h2>
        <!-- El formulario cambia según el proveedor. Sin decirlo, la diferencia entre una capa
             y otra parece arbitraria: es la confusión que reporta QA-72. -->
        <p v-if="providerLabel" class="layer-provider-note">
            Proveedor: <strong>{{ providerLabel }}</strong>
        </p>
    </div>

    <div class="container-body">
        <template v-if="currentForm">
            <component
                :is="currentForm"
                :categories="categories"
                :layerCreationMode="layer.provider.name"
                :isEdit="true"
                :initialData="layer"
                @toggle-status="onToggleStatus"
            />
        </template>
        <div v-else>
            Cargando información de la capa...
        </div>
    </div>
 
</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import FormularioGeoserver from "@/views/layers/addLayerForm/FormularioGeoserver";
import FormularioArcgis from "@/views/layers/addLayerForm/FormularioArcgis";

import {restLayer} from '@/components/mixin/restLayer.js'
import {restCategory} from '@/components/mixin/restCategory.js'
import { layerProviderLabel } from '@/services/layers/providerLabels.js'

export default{
    name: 'LayersEdit',
    mixins: [restLayer, restCategory],
    components:{
        Breadcrumb,
        FormularioGeoserver,
        FormularioArcgis
    },
    computed: {
        providerLabel() {
            if (!this.layer || !this.layer.provider || !this.layer.provider.name) return '';
            return layerProviderLabel(this.layer);
        },
        currentForm() {
            if (!this.layer || !this.layer.provider || !this.layer.provider.name) return null;
            
            const formMap = {
                geoserver: "FormularioGeoserver",
                arcgis: "FormularioArcgis",
                // 'file' might be handled as geoserver in some contexts or needs a specific form?
                // Based on previous code, 'file' provider was handled with geoserver fields.
                // If provider is 'file', we might want to use FormularioGeoserver but user logic in backend 
                // seems to differentiate. However, the original Edit view allowed editing 'file' provider 
                // using geoserver-like fields (filename, workspace).
                // Let's assume 'file' also uses FormularioGeoserver for metadata editing.
                file: "FormularioGeoserver" 
            };
            return formMap[this.layer.provider.name] || null;
        },
        routesBread: function(){
          return [
              {name:'Capas', path: '/capas' },
              {name: this.layer.name, path: '/capas/' + this.$route.params.idLayer},
              {name: 'Editar capa'}
              ]
        }
    },
    methods: {
        onToggleStatus: function(event) {
            var that = this;
            const newStatus = event.target.checked;
            const action = newStatus ? 'activar' : 'desactivar';
            this.$modal.show('dialog', {
                text: '¿Desea ' + action + ' la capa "' + this.layer.name + '"?',
                buttons: [
                    {
                        title: 'No',
                        handler: () => {
                            that.$modal.hide('dialog');
                            event.target.checked = !newStatus;
                        }
                    },
                    {
                        title: 'Sí',
                        handler: () => {
                            that.$modal.hide('dialog');
                            that.putLayerStatus(newStatus)
                                .then(() => { that.$set(that.layer, 'status', newStatus); })
                                .catch((error) => {
                                    console.log(error);
                                    event.target.checked = !newStatus;
                                    that.message = error.response.data.message;
                                });
                        }
                    }
                ]
            });
        }
    },
    mounted () {
        this.getCategoriesNoPages();
        this.getLayer();
    }
}
</script>

<style lang="scss" scoped>
.layer-provider-note {
    margin: 0.2rem 0 0;
    color: var(--color-ghost);
    font-size: 0.85rem;
}
</style>
